<template>
  <div class="ml-auto" >
    <v-simple-table dense class="summary-footer">
      <tbody>
        <tr>
          <th align="right">Subtotal</th>
          <td align="right">{{ formatCurrency(invoice.subtotal_cents) }}</td>
        </tr>
        <tr>
          <th align="right">Tax</th>
          <td align="right">{{ formatCurrency(invoice.tax_cents) }}</td>
        </tr>
        <tr>
          <th align="right">Total</th>
          <td align="right">{{ formatCurrency(invoice.total_cents) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'StatementFooter',

  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...formatters,
  }
}
</script>

<style scoped>
.summary-footer >>> th {
  border-bottom: none !important;
  padding-right: 24px !important;
  padding-left: 8px !important;
  height: 24px !important;
  font-size: 12px !important;
  text-align: right !important;
}

.summary-footer >>> td {
  border-bottom: none !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
  height: 24px !important;
  font-size: 12px !important;
}
</style>